<template>
  <v-container>
    <v-row>
      <v-col cols="12" class="py-0">
        <v-col cols="12" lg="6" class="d-flex justify-end py-0"></v-col>
      </v-col>
      <v-col lg="6">
        <div class="d-flex align-center">
          <h1 class="title font-weight-light mb-2 black--text">
            <v-icon left color="black">mdi-widgets</v-icon>
            Widgetlar
          </h1>
          <v-spacer></v-spacer>
          <language-selector v-model="currentLang" class="mr-2" />
          <v-btn color="green" small dark to="./widgets/new-widget">
            <v-icon size="18" left>mdi-plus-circle</v-icon>
            Widget Ekle
          </v-btn>
        </div>
        <v-divider class="mb-2"></v-divider>
        <p class="text-caption grey--text text--darken-2 mb-2">
          Widget'ları düzenleyebilir veya yeni ekleyebilirsiniz
        </p>
        <v-row>
          <v-col v-if="!allWidgetList || allWidgetListLoading">
            <v-skeleton-loader
              class="mb-3 elevation-1"
              type="list-item"
            ></v-skeleton-loader>
            <v-skeleton-loader
              class="mb-3 elevation-1"
              type="list-item"
            ></v-skeleton-loader>
            <v-skeleton-loader
              class="mb-3 elevation-1"
              type="list-item"
            ></v-skeleton-loader>
            <v-skeleton-loader
              class="mb-3 elevation-1"
              type="list-item"
            ></v-skeleton-loader>
            <v-skeleton-loader
              class="mb-3 elevation-1"
              type="list-item"
            ></v-skeleton-loader>
          </v-col>
          <v-col v-else-if="!allWidgetList.length">
            <p
              class="grey--text py-4 font-weight-medium text-body-1 d-flex align-center justify-center grey lighten-2"
            >
              <v-icon class="mr-1">mdi-emoticon-frown</v-icon>
              Sistemde tanımlı herhangi bir widget bulunamadı
            </p>
          </v-col>
          <v-col cols="12" v-else>
            <v-card
              :key="key"
              v-for="(widgetList, key) in allWidgetList"
              height="50"
              class="mb-3"
            >
              <v-row class="mx-0">
                <v-col
                  class="text-body-2 d-flex align-center font-weight-light"
                  cols="12"
                  md="4"
                >
                  <v-icon left>mdi-playlist-minus</v-icon>
                  {{ widgetList.name }}
                </v-col>
                <v-col
                  class="d-flex align-center text-caption font-weight-thin text-no-wrap"
                  cols="12"
                  md="4"
                >
                  {{ widgetList.sysname }}
                </v-col>
                <v-col cols="12" md="4" class="d-flex justify-end">
                  <v-tooltip bottom color="black">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-on="on"
                        v-bind="attrs"
                        icon
                        small
                        color="grey lighten-2"
                        class="mr-2"
                        @click="deleteWidgetConfirm(widgetList.sysname)"
                      >
                        <v-icon color="red darken-3" small>mdi-delete</v-icon>
                      </v-btn>
                    </template>
                    <span>Kaldır</span>
                  </v-tooltip>

                  <v-tooltip bottom color="black">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-on="on"
                        v-bind="attrs"
                        icon
                        small
                        color="grey lighten-2"
                        @click="getWidgetsList(widgetList.code)"
                      >
                        <v-icon color="blue darken-3" small>mdi-eye</v-icon>
                      </v-btn>
                    </template>
                    <span>Görüntüle</span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
      <v-col lg="6">
        <h1 class="title font-weight-light mb-2 black--text">
          <v-icon left color="black">mdi-view-grid-plus</v-icon>
          Kullanılabilir Widget Listesi
          <v-divider class="mt-2"></v-divider>
        </h1>
        <p class="text-caption grey--text text--darken-2 mb-2">
          Sistem tanımlı kullanılabilen widgetlar
        </p>
        <widget-preview :value="widgets" />
      </v-col>
    </v-row>

    <!--  Delete widget dialog  -->
    <v-dialog v-model="deleteWidget.dialog" persistent max-width="500">
      <v-card>
        <v-card-title class="headline red--text text--darken-4">
          <v-icon left color="red darken-4">mdi-close-octagon</v-icon>
          Uyarı
        </v-card-title>
        <v-card-text>
          Widget listesini silmek istediğinizden emin misiniz ?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="deleteWidget.dialog = false">
            İptal
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            :loading="deleteWidget.loading"
            @click="deleteWidgetList()"
          >
            Evet
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--  ./Delete widget dialog  -->
  </v-container>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import WidgetPreview from "../../../components/Settings/Widgets/WidgetPreview.vue";
import LanguageSelector from "@/components/Base/LanguageSelector.vue";

export default {
  name: "Widgets",
  components: { LanguageSelector, WidgetPreview },
  data() {
    return {
      deleteWidget: {
        sysName: "",
        dialog: false,
        loading: false
      },
      currentLang: null
    };
  },
  computed: {
    ...mapState({
      allWidgetList: state => state.Widget.WidgetLists.allWidgetList,
      allWidgetListLoading: state =>
        state.Widget.WidgetLists.allWidgetListLoading
    }),
    ...mapGetters({
      widgets: "Widget/Widgets/getWidgetsList"
    })
  },
  methods: {
    getWidgetsList(widgetListCode) {
      this.$store
        .dispatch("Widget/WidgetLists/getWidgetList", { widgetListCode })
        .then(({ status, data }) => {
          if (status === 200) {
            this.$router.push("/settings/widgets/widget/" + data[0].code);
          } else {
            this.$snotify.error(data.errMessage, this.$t('PANEL.NOTIFY.ERROR'));
          }
        });
    },
    getAllWidgetList(currentLang = null) {
      const lang = currentLang
        ? currentLang
        : this.$store.state.Language.apiLanguage;

      return this.$store.dispatch("Widget/WidgetLists/allWidgetList", {
        lang
      });
    },
    deleteWidgetList() {
      this.deleteWidget.loading = true;
      this.$store
        .dispatch(
          "Widget/WidgetLists/deleteWidgetList",
          this.deleteWidget.sysName
        )
        .then(res => {
          if (res.status === 200) {
            this.$snotify.success(
              "Widget başarıyla kaldırılmıştır",
              this.$t('PANEL.NOTIFY.SUCCESS')
            );
            this.getAllWidgetList();
            this.deleteWidget.dialog = false;
          } else {
            this.$snotify.error(res.data.errMessage, this.$t('PANEL.NOTIFY.ERROR'));
          }
        }).finally(() => {
          this.deleteWidget.loading = false;
      });
    },
    deleteWidgetConfirm(widgetListSysName) {
      this.deleteWidget.dialog = true;
      this.deleteWidget.sysName = widgetListSysName;
    }
  },
  created() {
    /**
     * Kullanılabilir Wigets Listesini Getir
     */
    this.$store.dispatch("Widget/Widgets/getWidgets");
  },

  watch: {
    currentLang() {
      /**
       * Widget Listelerini Getir
       */
      this.getAllWidgetList(this.currentLang.code);
    }
  }
};
</script>

<style scoped>
.widget-draggable-item {
  cursor: grab;
}

.widget-draggable-item:active {
  cursor: grabbing;
}
</style>